import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import {
// getLineStatus,
getLineTimes } from '@/service/operate/comprehensiveDaily';
export default function useLineStatus() {
  var lineStatusList = ref([]);
  // 查询时间范围内停机详情
  var getLineStatusAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getLineTimes();
          case 2:
            data = _context.sent;
            lineStatusList.value = data.list;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getLineStatusAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [lineStatusList, getLineStatusAsync];
}